import { Drawer } from "antd";
import { createGlobalStyle } from "styled-components";
import { PortalHeader } from "../../../../../components/molecules/Header";
import { portalDrawerAntHeaderCss } from "../../../../../components/molecules/Header/Header.styles";

const NotesDrawerTheme = createGlobalStyle`
  .notes-record-drawer .ant-drawer-content {
    background: #fff;
    border-left: 1px solid var(--PEARL, #ecf1f4);
    color: var(--GREY, #4a4a68);
    font-family: Inter, sans-serif;
  }
  .notes-record-drawer .ant-drawer-header {
    ${portalDrawerAntHeaderCss}
  }
  .notes-record-drawer .ant-drawer-title {
    font-family: inherit;
    width: 100%;
  }
  .notes-record-drawer .ant-drawer-body {
    display: flex;
    flex-direction: column;
    padding: 0;
    overflow: hidden;
  }
  .notes-record-drawer .ant-picker {
    width: 100%;
    height: 32px;
    font-family: Inter, sans-serif;
  }
  .ant-picker-dropdown {
    z-index: 11000;
  }
  .notes-record-drawer .ant-switch-checked {
    background: var(--BLUE, #2060ea);
  }
`;

export function NotesDrawer({ isOpen, title, supplementary, onClose, children }) {
  return (
    <>
      <NotesDrawerTheme />
      <Drawer
        open={isOpen}
        title={<PortalHeader title={title} supplementary={supplementary} onClose={onClose} />}
        rootClassName="notes-record-drawer"
        placement="right"
        width="min(880px, calc(100vw - 16px))"
        styles={{
          header: { padding: 0 },
          body: { padding: 0, overflow: "hidden" },
          mask: { backgroundColor: "rgba(0, 0, 0, 0.3)", backdropFilter: "blur(1px)" },
        }}
        onClose={onClose}
        closable={false}
        maskClosable={false}
        keyboard
        destroyOnClose
      >
        {children}
      </Drawer>
    </>
  );
}
